import { z } from "zod";
import { ParticipantIdField, TimestampField } from "./common";

/**
 * Integrator/Nango connection schemas
 * For OAuth integrations and third-party connections
 */

// Nango connection data
export const NangoConnectionData = z.object({
  participantId: ParticipantIdField,
  integrationId: z.string().min(1),
  connectionId: z.string().min(1),
  provider: z.string().min(1),
  createdAt: TimestampField,
  metadata: z.record(z.string(), z.unknown()).optional(),
});

type NangoConnectionDataType = z.infer<typeof NangoConnectionData>;

// Nango store interface (not a Zod schema, just a TypeScript interface)
export interface NangoStore {
  addConnection(data: NangoConnectionDataType): void;
  getConnection(participantId: string, integrationId: string): NangoConnectionDataType | undefined;
  getParticipantConnections(participantId: string, integrationId?: string): NangoConnectionDataType[];
  deleteConnection(participantId: string, integrationId: string): void;
}

// Integration configuration
export const IntegrationConfig = z.object({
  scopes: z.string(),
  provider: z.string(),
});

// export type IntegrationConfig = z.infer<typeof IntegrationConfig>;

// Session creation request/response
export const CreateSessionRequest = z.object({
  participantId: ParticipantIdField,
  integrationId: z.string().min(1),
  provider: z.string().min(1),
});

// export type CreateSessionRequest = z.infer<typeof CreateSessionRequest>;

export const CreateSessionResponse = z.object({
  sessionToken: z.string(),
  integrationId: z.string(),
  participantId: z.string(),
});

// export type CreateSessionResponse = z.infer<typeof CreateSessionResponse>;

// Proxy request
export const ProxyRequest = z.object({
  participantId: ParticipantIdField,
  integrationId: z.string().min(1),
  endpoint: z.string().min(1),
  method: z.enum(["GET", "POST", "PUT", "DELETE", "PATCH"]).default("GET"),
  data: z.unknown().optional(),
});

// export type ProxyRequest = z.infer<typeof ProxyRequest>;

export const integratorSchemas = {
  NangoConnectionData,
  IntegrationConfig,
  CreateSessionRequest,
  CreateSessionResponse,
  ProxyRequest,
};

